define("settings/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('overview', function () {
      this.route('display');
      this.route('downgrade');
      this.route('edit');
      this.route('edit-email');
      this.route('leave');
      this.route('password');
      this.route('preferences');
      this.route('two_factor');
    });
    this.route('groups', function () {
      this.route('new');
      this.route('trade');
      this.route('group', {
        path: '/:group_id'
      }, function () {
        this.route('edit');
        this.route('social_profiles', function () {
          this.route('new', function () {
            this.route('facebook');
          });
          this.route('edit', {
            path: ':social_profile_id/edit'
          });
          this.route('confirm', {
            path: ':social_profile_id/confirm'
          });
        });
        this.route('members', function () {
          this.route('new');
          this.route('edit', {
            path: ':user_id/edit'
          });
        });
        this.route('contributors', function () {
          this.route('new');
        });
        this.route('integrations');
        this.route('meta_ad_accounts');
      });
    });
    this.route('users', function () {
      this.route('new');
      this.route('remove', {
        path: '/:user_id/remove'
      });
    });
    this.route('subscription', function () {
      this.route('cancel');
      this.route('billing', function () {
        this.route('edit');
        this.route('email');
        this.route('address');
        this.route('info');
        this.route('tax_id');
        this.route('payment_method');
      });
    });
    this.route('billing');
    this.route('devices');
    this.route('404', {
      path: '*'
    });
  });
});